import * as Sentry from "@sentry/browser"

const spans = new Map<string, Sentry.Span>()

export const startInactiveSpan = ({ name, op }: { name: string; op: string }) => {
  if (IS_DEVELOPMENT) {
    console.time(name)
  }

  const span = Sentry.startInactiveSpan({ name, op })

  if (span) {
    spans.set(name, span)
  }
}

export const finishInactiveSpan = ({ name }: { name: string }) => {
  if (IS_DEVELOPMENT) {
    console.timeEnd(name)
  }

  spans.get(name)?.finish()
  spans.delete(name)
}
